import { SPOT_ILLUSTRATION_VERSION_FOLDER } from './versions';
export const SPOT_ILLUSTRATION_FILE_PATHS = {
  storybook: `./${SPOT_ILLUSTRATION_VERSION_FOLDER}/`,
  local: `https://frontends-dev.udemycdn.com/design-system/illustrations/${SPOT_ILLUSTRATION_VERSION_FOLDER}/`,
  dev: `https://frontends-dev.udemycdn.com/design-system/illustrations/${SPOT_ILLUSTRATION_VERSION_FOLDER}/`,
  prod: `https://frontends.udemycdn.com/design-system/illustrations/${SPOT_ILLUSTRATION_VERSION_FOLDER}/`
};
//# sourceMappingURL=spot-asset-links.js.map